import { createSelector } from '@reduxjs/toolkit';
import { selectSelectedProject } from 'store/projects/selectors/projectsSelectors';

const selectProjectUsersState = (state) => state.projectUsers;

export const selectProjectUsers = createSelector(
  [selectProjectUsersState],
  (state) => state.users.entities
);

export const selectProjectUsersPersonalResources = createSelector(
  [selectProjectUsersState],
  (state) => state.userPersonalResources.entities
);

export const selectProjectUsersArray = createSelector(
  [selectProjectUsers],
  (users) => Object.values(users)
);

export const selectEmployeeBusinessConfigurationsByBusinessId = createSelector(
  [selectProjectUsersState],
  (state) => state.employeeBusinessConfigurationsByBusinessId
);

export const selectEmployeeConfigurationsOfEmployerByBusinessId =
  createSelector(
    [
      selectEmployeeBusinessConfigurationsByBusinessId,
      selectSelectedProject,
      (_, businessId) => businessId,
    ],
    (employeeConfigurationsByBusinessId, selectedProject, businessId) => {
      const effectiveBusinessId = businessId
        ? businessId
        : selectedProject.business_id;

      const configurations = employeeConfigurationsByBusinessId[
        effectiveBusinessId
      ]
        ? employeeConfigurationsByBusinessId[effectiveBusinessId]
        : [];

      return configurations;
    }
  );
export const selectIsAddNewUserDialogOpen = createSelector(
  [selectProjectUsersState],
  (state) => state.isAddNewUserDialogOpen
);

export const selectAddNewUserDialogMeta = createSelector(
  [selectProjectUsersState],
  (state) => state.addNewUserDialogMeta
);

export const selectIsJoinEmployeeToProjectDialogOpen = createSelector(
  [selectProjectUsersState],
  (state) => state.isJoinEmployeeToProjectDialogOpen
);

export const selectJoinEmployeeToProjectDialogMeta = createSelector(
  [selectProjectUsersState],
  (state) => state.joinEmployeeToProjectDialogMeta
);

export const selectJoinEmployeeSelectedBusinessId = createSelector(
  [selectProjectUsersState],
  (state) => state.joinEmployeeSelectedBusinessId
);

export const selectLatestOrientationFlowResult = createSelector(
  [selectProjectUsersState],
  (state) => state.latestOrientationFlowResult
);
